import { useEffect, useRef } from "react";

/**
 * Mantém em memória o valor da renderização anterior.
 *
 * @param {*} value Valor atual que deve ser preservado entre renderizações
 *
 * @description
 * Este hook realiza as seguintes operações:
 * 1. Inicializa uma referência com o valor recebido
 * 2. Atualiza a referência após cada renderização
 * 3. Retorna o valor armazenado na renderização anterior
 *
 * @returns {*} Valor anterior armazenado na referência
 */
const usePrevious = (value) => {
  const ref = useRef(value); //const ref = useRef(); // Inicializa o ref com o valor inicial
  useEffect(() => {
    ref.current = value; // Atualiza o valor do ref quando o valor do estado muda
  });
  return ref.current; // Retorna o valor do ref
};

export default usePrevious;
